const hasShadowDom = (el) => {
    return !!el.shadowRoot && !!el.attachShadow;
};
const debounceEvent = (event, wait) => {
    const original = event._original || event;
    return {
        _original: event,
        emit: debounce(original.emit.bind(original), wait),
    };
};
const debounce = (func, wait = 0) => {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(func, wait, ...args);
    };
};
const setColor = (color) => {
    var _a;
    if (!color)
        return;
    const colors = {
        primary: 'var(--pine-color-text-primary)',
        secondary: 'var(--pine-color-text-secondary)',
        neutral: 'var(--pine-color-text-neutral)',
        accent: 'var(--pine-color-text-accent)',
        danger: 'var(--pine-color-text-danger)',
        info: 'var(--pine-color-text-info)',
        success: 'var(--pine-color-text-success)',
        warning: 'var(--pine-color-text-warning)',
    };
    return {
        '--color': (_a = colors[color]) !== null && _a !== void 0 ? _a : (color.startsWith('--') ? `var(${color})` : color)
    };
};

export { debounceEvent as d, hasShadowDom as h, setColor as s };
//# sourceMappingURL=utils.js.map

//# sourceMappingURL=utils.js.map